module.exports = __webpack_public_path__ + "static/media/alignCenter.638db817.svg";